import { useSetToast } from "@app/components/Toast";
import { useUpdateObjective } from "@app/screens/Objectives/data";
import { Textarea } from "@design-system/Inputs/Textarea";
import { GetObjectiveQuery, ResponseStatus } from "@generated/client/graphql";
import { ChangeEvent, FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { RESOURCE_NAME, keys } from "./i18n";
import { Box } from "@design-system/Layout/Box";
import { isObjectiveEditable } from "../../services";

type ObjectiveDescriptionProps = {
    objective: GetObjectiveQuery["objective"];
};

export const ObjectiveDescription: FC<ObjectiveDescriptionProps> = ({
    objective,
}) => {
    const canEditObjective = useMemo(
        () => isObjectiveEditable(objective),
        [objective],
    );
    const [description, setDescription] = useState<string | undefined>(
        objective?.description || undefined,
    );
    const { mutate } = useUpdateObjective(objective?.id, objective?.entityId);
    const { setToastError } = useSetToast();
    const handleDescriptionSave = () => {
        if (description !== objective.description) {
            const newDescription = description || null;
            mutate(
                { id: objective.id, description: newDescription },
                {
                    onSettled: (data) => {
                        if (
                            data?.updateObjective?.status ===
                            ResponseStatus.Error
                        ) {
                            setToastError(
                                `${data.updateObjective.error?.message}`,
                            );
                        }
                    },

                    onError: () => {
                        setToastError(t(keys.update_error));
                    },
                },
            );
        }
    };

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setDescription(event.target.value || undefined);
    };
    const { t } = useTranslation(RESOURCE_NAME);

    return (
        <Box
            className={
                !canEditObjective
                    ? "pointer-events-none cursor-not-allowed"
                    : ""
            }
        >
            <Textarea
                value={description}
                onChange={handleChange}
                onBlur={handleDescriptionSave}
                cols={6}
            />
        </Box>
    );
};
